// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleCarousel_root__C17jB","bullet":"ArticleCarousel_bullet__cfk5I","arrowWrapper":"ArticleCarousel_arrowWrapper__2SKgb"};